import React, { Component } from 'react'
import { Form, DatePicker, Input, Button, Popconfirm, message, Spin } from 'antd'
import moment from 'moment'
import { validateDate } from '../util'

const FormItem = Form.Item
const propTypes = {}

class ScheduleSiteWorkDatesView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false
    }
  }

  componentWillUnmount() {
    this.props.clearHighlight()
  }

  handleSaveDatesClick = () => {
    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      let transformedDates = {}
      let scheduleType = null
      const currentDates = this.props.data
      Object.keys(values).forEach(function(key, value) {
        if (values[key] !== null) {
          if (moment.isMoment(values[key])) {
            if (!moment(values[key]).isSame(currentDates[key])) {
              scheduleType = key
            }
          }
        }
        transformedDates[key] = validateDate(values[key])
      })
      this.props.updateSiteWorkDates({
        jobId: this.props.jobId,
        scheduleId: this.props.machineIndex,
        userId: this.props.userId,
        content: transformedDates,
        scheduleType: scheduleType
      })

      form.resetFields()
      this.props.clearFields()
    })
    this.setState({
      isEditing: false
    })
  }

  handleNotesBlur = e => {
    this.props.updateNotes({
      jobId: this.props.jobId,
      scheduleId: this.props.machineIndex,
      userId: this.props.userId,
      notes: e.target.value
    })
    message.success('Notes saved.')
  }

  handleCancelEditClick = () => {
    this.props.clearFields()
  }

  cancelDelete = () => {
    this.props.clearFields()
  }

  confirmDelete = () => {
    this.props.deleteSchedule(this.props.machineIndex)
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { data, isEditing } = this.props

    if (!data) {
      return <Spin size="large" />
    }

    return (
      <div>
        <Form layout="vertical">
          <div className="row sceduleTitleRow">
            <div className="col-md-9">
              {!isEditing && <h2>{data.name}</h2>}
              {isEditing && (
                <div>
                  <FormItem>
                    {getFieldDecorator('name', {
                      rules: [
                        {
                          required: true,
                          message: 'Schedule device must have a name.'
                        }
                      ],
                      initialValue: data.name
                    })(<Input />)}
                  </FormItem>
                </div>
              )}
            </div>
            <div className="col-md-3">
              {isEditing && (
                <div className="datesButtonArea">
                  <Button type="primary" icon="save" onClick={() => this.handleSaveDatesClick()} />
                  <Button
                    type="default"
                    icon="close"
                    className="marginRight10"
                    onClick={() => this.handleCancelEditClick()}
                  />
                </div>
              )}
            </div>
          </div>
          {data && (
            <div>
              {/* LINE 1 */}
              <div className="row padding10-all">
                <div className="col-6">
                  <div className="jobDetailsHeader">Customer Requested Start</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('customer_requested_start_date', {
                        initialValue: moment(data.customer_requested_start_date).isValid()
                          ? moment(data.customer_requested_start_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.customer_requested_start_date !== null
                        ? moment(data.customer_requested_start_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-6">
                  <div className="jobDetailsHeader">Estimated Start</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('estimated_start_date', {
                        initialValue: moment(data.estimated_start_date).isValid()
                          ? moment(data.estimated_start_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.estimated_start_date !== null
                        ? moment(data.estimated_start_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
              </div>
              {/* LINE 2 */}
              <div className="row padding10-all">
                <div className="col-6">
                  <div className="jobDetailsHeader">Confirmed Start</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('confirmed_start_date', {
                        initialValue: moment(data.confirmed_start_date).isValid()
                          ? moment(data.confirmed_start_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.confirmed_start_date !== null
                        ? moment(data.confirmed_start_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-6" />
              </div>
              {/* LINE 3 */}
              <div className="row padding10-all">
                <div className="col-6">
                  <div className="jobDetailsHeader">Estimated Adjusting</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('estimated_adjusting_date', {
                        initialValue: moment(data.estimated_adjusting_date).isValid()
                          ? moment(data.estimated_adjusting_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.estimated_adjusting_date !== null
                        ? moment(data.estimated_adjusting_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-6">
                  <div className="jobDetailsHeader">Confirmed Adjusting</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('confirmed_adjusting_date', {
                        initialValue: moment(data.confirmed_adjusting_date).isValid()
                          ? moment(data.confirmed_adjusting_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.confirmed_adjusting_date !== null
                        ? moment(data.confirmed_adjusting_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 text-right">
                  <Popconfirm
                    title="Are you sure you want to delete this schedule?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button className="marginRight20" type="danger" icon="delete" />
                  </Popconfirm>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    )
  }
}

ScheduleSiteWorkDatesView.propTypes = propTypes
export default Form.create()(ScheduleSiteWorkDatesView)



// WEBPACK FOOTER //
// ./src/components/ScheduleSiteWorkDatesView.js